// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 1024px) {
  .col-sm-1 {
    width: 8.33%;
  }
  .col-sm-2 {
    width: 16.66%;
  }
  .col-sm-3 {
    width: 25%;
  }
  .col-sm-4 {
    width: 33.33%;
  }
  .col-sm-5 {
    width: 41.66%;
  }
  .col-sm-6 {
    width: 50%;
  }
  .col-sm-7 {
    width: 58.33%;
  }
  .col-sm-8 {
    width: 66.66%;
  }
  .col-sm-9 {
    width: 75%;
  }
  .col-sm-10 {
    width: 83.33%;
  }
  .col-sm-11 {
    width: 91.66%;
  }
  .col-sm-12 {
    width: 100%;
  }
  .col-sm-offset-1 {
    margin-left: 8.33%;
  }
  .col-sm-offset-2 {
    margin-left: 16.66%;
  }
  .col-sm-offset-3 {
    margin-left: 25%;
  }
  .col-sm-offset-4 {
    margin-left: 33.33%;
  }
  .col-sm-offset-5 {
    margin-left: 41.66%;
  }
  .col-sm-offset-6 {
    margin-left: 50%;
  }
  .col-sm-offset-7 {
    margin-left: 58.33%;
  }
  .col-sm-offset-8 {
    margin-left: 66.66%;
  }
  .col-sm-offset-9 {
    margin-left: 75%;
  }
  .col-sm-offset-10 {
    margin-left: 83.33%;
  }
  .col-sm-offset-11 {
    margin-left: 91.66%;
  }
  .col-sm-offset-12 {
    margin-left: 100%;
  }
}
@media (min-width: 1025px) {
  .col-md-1 {
    width: 8.33%;
  }
  .col-md-2 {
    width: 16.66%;
  }
  .col-md-3 {
    width: 25%;
  }
  .col-md-4 {
    width: 33.33%;
  }
  .col-md-5 {
    width: 41.66%;
  }
  .col-md-6 {
    width: 50%;
  }
  .col-md-7 {
    width: 58.33%;
  }
  .col-md-8 {
    width: 66.66%;
  }
  .col-md-9 {
    width: 75%;
  }
  .col-md-10 {
    width: 83.33%;
  }
  .col-md-11 {
    width: 91.66%;
  }
  .col-md-12 {
    width: 100%;
  }
  .col-md-offset-1 {
    margin-left: 8.33%;
  }
  .col-md-offset-2 {
    margin-left: 16.66%;
  }
  .col-md-offset-3 {
    margin-left: 25%;
  }
  .col-md-offset-4 {
    margin-left: 33.33%;
  }
  .col-md-offset-5 {
    margin-left: 41.66%;
  }
  .col-md-offset-6 {
    margin-left: 50%;
  }
  .col-md-offset-7 {
    margin-left: 58.33%;
  }
  .col-md-offset-8 {
    margin-left: 66.66%;
  }
  .col-md-offset-9 {
    margin-left: 75%;
  }
  .col-md-offset-10 {
    margin-left: 83.33%;
  }
  .col-md-offset-11 {
    margin-left: 91.66%;
  }
  .col-md-offset-12 {
    margin-left: 100%;
  }
}
.startdate-tab {
  margin: 0 16.66%;
}
.startdate-tab .table {
  margin-bottom: 0px !important;
}
.startdate-tab .mixedCombination .already-enrolled-devices, .startdate-tab .mixedCombination .change-device-enrollment-dates {
  padding-top: 20px;
}
.startdate-tab .date-picker tbody {
  color: #5a5a5a;
  font-size: 16px;
}
.startdate-tab .popupBreak {
  margin-top: 20px;
}
.startdate-tab .checkboxHeader {
  margin-left: 34px;
  font: 24px Omnes-ATT-W02-Medium;
}
.startdate-tab .back-button-enrollDate {
  padding-right: 40px;
}
.startdate-tab .icon-alert {
  color: #ffb81c !important;
  margin: 0;
}
.startdate-tab .enrollDateInfo {
  padding: 30px 0 0;
  margin: 0;
}
.startdate-tab .enrollDateInfo a {
  padding: 0;
}
.startdate-tab .enrollDateInfo .alert-icon {
  width: 20px;
  float: left;
  margin-right: 10px;
}
.startdate-tab .enrollDateInfo .extra-content {
  float: left;
  width: 88%;
}
.startdate-tab .enrollDateInfo .icon-alert {
  width: 20px;
  height: 20px;
}
.startdate-tab .btn-link {
  font: 1.8rem "Omnes-ATT-W02";
}
.startdate-tab tr th:first-child {
  width: 15%;
}
.startdate-tab .list-container {
  margin-top: 30px;
}
.startdate-tab .padding {
  padding-left: 15px;
}
.startdate-tab h2 {
  margin-bottom: 30px;
}
.startdate-tab ul li {
  list-style-type: disc;
  margin-left: 15px;
}
.startdate-tab .bullet {
  list-style-type: none;
}
.startdate-tab a {
  cursor: pointer;
  padding-right: 30px;
}
.startdate-tab .model-box a {
  padding-right: 19px;
}
.startdate-tab .select-dates {
  margin: 20px 0 0;
}
.startdate-tab .select-dates .device-header {
  position: relative;
}
.startdate-tab .select-dates .device-header h3 {
  display: inline-block;
  font-size: 20px;
  margin-bottom: 10px;
}
.startdate-tab .select-dates .device-header h4, .startdate-tab .select-dates .device-header .disable-label, .startdate-tab .select-dates .device-header .enable-label {
  display: inline-block;
  font-size: 14px;
  margin-bottom: 10px;
}
.startdate-tab .select-dates .device-header h4.disable-label, .startdate-tab .select-dates .device-header .disable-label.disable-label, .startdate-tab .select-dates .device-header .enable-label.disable-label {
  color: #5a5a5a;
}
.startdate-tab .select-dates .device-header .tooltip-container {
  border: none;
  font-size: 17px;
  position: relative;
  top: -4px;
}
.startdate-tab .select-dates .enter-date {
  width: 61%;
}
.startdate-tab .select-dates .error-msg {
  color: hsl(0, 66%, 49%);
  font-family: "Omnes-ATT-W02-Medium";
  font-size: 14px;
}
.startdate-tab .select-dates .error-msg i {
  color: hsl(0, 66%, 49%);
  font-size: 15px;
  margin-right: 4px;
}
.startdate-tab .ios-message {
  border-radius: 6px;
  border-radius: 6px;
  border-radius: 6px;
  border-radius: 6px;
  border-radius: 6px;
  background-color: hsl(0, 0%, 95%);
  border: 1px solid hsl(0, 0%, 95%);
  margin: 20px 0 30px;
  padding: 20px;
}
.startdate-tab .acc-content {
  padding-bottom: 20px;
}
.startdate-tab .cta {
  border-top: 1px solid #d2d2d2;
  margin-top: 30px;
  margin-bottom: 30px;
  padding: 30px 0 46px;
}
.startdate-tab .cta a,
.startdate-tab .cta button {
  float: right;
}
.startdate-tab .error-container .message {
  font-family: "Omnes-ATT-W02";
  font-size: 14px;
  padding: 3px 0;
}
.startdate-tab .accheader {
  font-family: "Omnes-ATT-W02";
}
.startdate-tab .accordion {
  border-bottom: 1px solid #d2d2d2;
}
.startdate-tab .supportArticles {
  margin-bottom: 60px;
}
@media (max-width: 1024px) {
  .startdate-tab {
    margin: 0px;
    padding: 0 4%;
    width: 100%;
  }
  .startdate-tab .supportArticles {
    margin-bottom: 30px;
  }
  .startdate-tab h2 {
    margin-bottom: 20px;
  }
  .startdate-tab .select-dates {
    width: 100%;
  }
  .startdate-tab .select-dates .device-header h3 {
    font-size: 16px;
  }
  .startdate-tab .select-dates .device-header h4 {
    font-size: 12px;
  }
  .startdate-tab .select-dates .device-header .tooltip-container {
    position: static;
  }
  .startdate-tab .select-dates .device-header .helper-text {
    border-radius: 0;
    left: -4%;
    width: 108%;
    top: 31px;
  }
  .startdate-tab .select-dates .enter-date {
    width: 100%;
  }
  .startdate-tab .grid-table {
    margin-left: -4%;
    margin-right: -4%;
  }
  .startdate-tab .ios-message {
    margin: 20px 0;
    padding: 20px 0;
  }
  .startdate-tab .cta {
    margin-top: 20px;
    margin-bottom: 20px;
    padding: 20px 0 70px;
    text-align: center;
  }
  .startdate-tab .cta .btn {
    margin-bottom: 5px;
    width: 100%;
  }
  .startdate-tab .cta .a {
    padding: 20px;
  }
  .startdate-tab .error-container {
    margin: 0 -4% 15px -4%;
    border-radius: 0;
  }
  .startdate-tab .error-container div {
    border-radius: 0;
  }
  .startdate-tab .error-container .message {
    font-size: 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/lib/ng2-sapmp/src/assets/style/mixinfunction.scss","webpack://./src/lib/ng2-sapmp/src/assets/style/variables.scss","webpack://./src/app/pages/signup/startdate/startdate.component.scss"],"names":[],"mappings":"AAwBI;EA4BA;IACE,YClDE;ECAN;EFiDE;IACE,aClDE;ECGN;EF8CE;IACE,UClDE;ECMN;EF2CE;IACE,aClDE;ECSN;EFwCE;IACE,aClDE;ECYN;EFqCE;IACE,UClDE;ECeN;EFkCE;IACE,aClDE;ECkBN;EF+BE;IACE,aClDE;ECqBN;EF4BE;IACE,UClDE;ECwBN;EFyBE;IACE,aClDE;EC2BN;EFsBE;IACE,aClDE;EC8BN;EFmBE;IACE,WClDE;ECiCN;EFqBE;IACE,kBCvDE;ECoCN;EFkBE;IACE,mBCvDE;ECuCN;EFeE;IACE,gBCvDE;EC0CN;EFYE;IACE,mBCvDE;EC6CN;EFSE;IACE,mBCvDE;ECgDN;EFME;IACE,gBCvDE;ECmDN;EFGE;IACE,mBCvDE;ECsDN;EFAE;IACE,mBCvDE;ECyDN;EFHE;IACE,gBCvDE;EC4DN;EFNE;IACE,mBCvDE;EC+DN;EFTE;IACE,mBCvDE;ECkEN;EFZE;IACE,iBCvDE;ECqEN;AACF;AF7CI;EAoCA;IACE,YC9DE;EC0EN;EFbE;IACE,aC9DE;EC6EN;EFhBE;IACE,UC9DE;ECgFN;EFnBE;IACE,aC9DE;ECmFN;EFtBE;IACE,aC9DE;ECsFN;EFzBE;IACE,UC9DE;ECyFN;EF5BE;IACE,aC9DE;EC4FN;EF/BE;IACE,aC9DE;EC+FN;EFlCE;IACE,UC9DE;ECkGN;EFrCE;IACE,aC9DE;ECqGN;EFxCE;IACE,aC9DE;ECwGN;EF3CE;IACE,WC9DE;EC2GN;EFzCE;IACE,kBCnEE;EC8GN;EF5CE;IACE,mBCnEE;ECiHN;EF/CE;IACE,gBCnEE;ECoHN;EFlDE;IACE,mBCnEE;ECuHN;EFrDE;IACE,mBCnEE;EC0HN;EFxDE;IACE,gBCnEE;EC6HN;EF3DE;IACE,mBCnEE;ECgIN;EF9DE;IACE,mBCnEE;ECmIN;EFjEE;IACE,gBCnEE;ECsIN;EFpEE;IACE,mBCnEE;ECyIN;EFvEE;IACE,mBCnEE;EC4IN;EF1EE;IACE,iBCnEE;EC+IN;AACF;AAjJA;EAKE,gBAAA;AA+IF;AAlJE;EACE,6BAAA;AAoJJ;AA1II;EACE,iBAAA;AA4IN;AAxII;EACE,cAAA;EACA,eAAA;AA0IN;AArIA;EACE,gBAAA;AAuIF;AApIA;EACE,iBAAA;EACA,+BAAA;AAsIF;AAnIE;EACE,mBAAA;AAqIJ;AAnIE;EACE,yBAAA;EACA,SAAA;AAqIJ;AAlIE;EACE,iBAAA;EACA,SAAA;AAoIJ;AAlII;EACE,UAAA;AAoIN;AAjII;EACE,WAAA;EACA,WAAA;EACA,kBAAA;AAmIN;AAhII;EACE,WAAA;EACA,UAAA;AAkIN;AA/HI;EACE,WAAA;EACA,YAAA;AAiIN;AA7HE;EACE,4BAAA;AA+HJ;AA3HM;EACE,UAAA;AA6HR;AAzHE;EACE,gBAAA;AA2HJ;AAxHE;EACE,kBAAA;AA0HJ;AAvHE;EACE,mBAAA;AAyHJ;AArHI;EACE,qBAAA;EACA,iBAAA;AAuHN;AAlHE;EACE,qBAAA;AAoHJ;AAhHE;EACE,eAAA;EACA,mBAAA;AAkHJ;AA/GE;EACE,mBAAA;AAiHJ;AA9GE;EACE,gBAAA;AAgHJ;AA9GI;EACE,kBAAA;AAgHN;AA9GM;EACE,qBAAA;EACA,eAAA;EACA,mBAAA;AAgHR;AA7GM;EACE,qBAAA;EACA,eAAA;EACA,mBAAA;AA+GR;AA9GQ;EACE,cAAA;AAgHV;AA5GM;EACE,YAAA;EACA,eAAA;EACA,kBAAA;EACA,SAAA;AA8GR;AA1GI;EACE,UAAA;AA4GN;AAzGI;EACE,uBAAA;EACA,mCAAA;EACA,eAAA;AA2GN;AAzGM;EACE,uBAAA;EACA,eAAA;EACA,iBAAA;AA2GR;AAtGE;EF3HE,kBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,kBAAA;EE6HA,iCAAA;EACA,iCAAA;EACA,mBAAA;EACA,aAAA;AA4GJ;AAzGE;EACE,oBAAA;AA2GJ;AAxGE;EACE,6BAAA;EACA,gBAAA;EACA,mBAAA;EACA,oBAAA;AA0GJ;AAxGI;;EAEE,YAAA;AA0GN;AArGI;EACE,4BAAA;EACA,eAAA;EACA,cAAA;AAuGN;AAnGE;EAEE,4BAAA;AAoGJ;AAjGE;EACE,gCAAA;AAmGJ;AAhGE;EACE,mBAAA;AAkGJ;AFnRI;EEtBJ;IA2MI,WAAA;IACA,aAAA;IACA,WAAA;EAkGF;EAhGE;IACE,mBAAA;EAkGJ;EA/FE;IACE,mBAAA;EAiGJ;EA9FE;IACE,WAAA;EAgGJ;EA5FM;IACE,eAAA;EA8FR;EA3FM;IACE,eAAA;EA6FR;EA1FM;IACE,gBAAA;EA4FR;EAzFM;IACE,gBAAA;IACA,SAAA;IACA,WAAA;IACA,SAAA;EA2FR;EAvFI;IACE,WAAA;EAyFN;EArFE;IACE,gBAAA;IACA,iBAAA;EAuFJ;EApFE;IACE,cAAA;IACA,eAAA;EAsFJ;EAnFE;IACE,gBAAA;IACA,mBAAA;IACA,oBAAA;IACA,kBAAA;EAqFJ;EAnFI;IACE,kBAAA;IACA,WAAA;EAqFN;EAlFI;IACE,aAAA;EAoFN;EAhFE;IACE,sBAAA;IACA,gBAAA;EAkFJ;EAhFI;IACE,gBAAA;EAkFN;EA/EI;IACE,eAAA;EAiFN;AACF","sourcesContent":["@import 'variables';\n\n@function color($color-name, $color-variant: null) {\n  // color variant is optional\n  @if ($color-variant != null) {\n    // map inception\n    @return map-get(map-get($colors, $color-name), $color-variant);\n  }@else {\n    @return map-get($colors, $color-name);\n  }\n}\n// buttons building section\n\n$btns: (\n  default: color(default, base),\n  primary: color(primary, base),\n  secondary:  color(secondary, base),\n  inverse: color(inverse, light),\n  success: color(success, base),\n  danger:  color(danger, base)\n);\n\n@mixin respond-to($breakpoint) {\n  @if $breakpoint == 'small' {\n    @media (max-width: 1024px) {\n      @content;\n    }\n  }@else if $breakpoint == 'large' {\n    @media (min-width: 1025px) {\n      @content;\n    }\n  }\n}\n\n@mixin vendor-prefix($name, $value) {\n  @each $vendor in ('-webkit-', '-moz-', '-ms-', '-o-', '') {\n    #{$name}: #{$value};\n  }\n}\n\n\n@mixin placeholder() {\n  color: color(inverse, light) !important;\n  font-family: 'Omnes-ATT-W02-Italic'!important;\n  font-style: normal;\n  opacity: 1;\n  font-size: 16px;\n}\n\n// dynamic\n@include respond-to(small) {\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n@include respond-to (large) {\n  @each $gridname, $gridvalue in $grids {\n    .col-md-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-md-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n","// Global Variables\n@import './../../../../../assets/style/var-config';\n// grids here\n$grids: (\n  1: 8.33%,\n  2: 16.66%,\n  3: 25%,\n  4: 33.33%,\n  5: 41.66%,\n  6: 50%,\n  7: 58.33%,\n  8: 66.66%,\n  9: 75%,\n  10: 83.33%,\n  11: 91.66%,\n  12: 100%\n);\n\n\n// refer http://digitaldesign.web.att.com/getstarted-color.html\n$att-dark-blue: hsl(205, 94%, 35%); // #0568ae\n$f-red: hsl(0, 66%, 49%); // #cf2a2a Functional Red\n$fb-gray: hsl(0, 0%, 95%); // #f2f2f2 Functional background Gray\n$att-dark-gray: hsl(0, 0%, 35%); // #5a5a5a\n$f-green: hsl(150, 100%, 24%); // #007a3e functional Green\n// $att-orange: hsl(30, 100%, 46%); // #ea7400 ATT Orange\n$att-orange: #ea7400; //ATT Orange\n\n// set color map easy use variables\n$primary: $att-orange !default;\n$secondary: $att-dark-blue !default;\n$default: $fb-gray !default;\n$inverse: $att-dark-gray !default;\n$danger: $f-red !default;\n$success: $f-green !default;\n\n\n// color variable map\n$colors: (\n  info: #009fdb,\n  enrolledActive:  #66cc00,\n  enrolledNotActive: #70c5e9,\n  notEnrolled: #fdb91d,\n  outOfCompliance: #cccccc,\n  appleNotinstalled: #fcbb15, \n\n  // Primary - Blue color\n  primary: (\n    base: $primary,\n    light: lighten($primary, 15%),\n    lightest: lighten($primary, 60%),\n    dark: darken($primary, 15%)\n  ),\n\n  // Secondary - Orange color\n  secondary: (\n    base: $secondary,\n    light: lighten($secondary, 15%),\n    lightest: lighten($secondary, 60%),\n    dark: darken($secondary, 15%)\n  ),\n\n  // default - Gray color\n  default: (\n    base: $default,\n    light: lighten($default, 5%), // #fff white\n    dark: darken($default, 12.8%), // #d2d2d2 ATT Light Gray\n    darker: darken($default, 18%) // #c4c4c4\n  ),\n\n  // Inverse - Black color\n  inverse: (\n    base: $inverse,\n    light: lighten($inverse, 11.25%), // #767676 Auxiliary Gray\n    lightest: lighten($inverse, 25%), // #999999\n    lighter: lighten($inverse, 23.4%), // #959595 ATT Gray\n    dark: darken($inverse, 15%), // #333 ATT Dark Gray (2015)\n    darker: darken($inverse, 25.2%), // #191919 Functional Digital Text Black\n    darkest: darken($inverse, 35%) // #000 \n  ),\n\n  // danger - Red color\n  danger: (\n    base: $danger,\n    light: lighten($danger, 15%),\n    dark: darken($danger, 15%)\n  ),\n\n  // success - Green color\n  success: (\n    base: $success,\n    light: lighten($success, 15%),\n    dark: darken($success, 15%)\n  )\n);\n","@import '../../../../lib/ng2-sapmp/src/assets/style/mixinfunction';\n\n.startdate-tab {\n\n  .table {\n    margin-bottom: 0px !important;\n  }\n  margin: 0 16.66%;\n\n  // .grid-table {\n  //   margin-left: -4%;\n  //   margin-right: -4%;\n  // }\n\n  .mixedCombination {\n    .already-enrolled-devices, .change-device-enrollment-dates {\n      padding-top: 20px;\n    }\n  }\n  .date-picker {\n    tbody {\n      color: #5a5a5a;\n      font-size: 16px;\n    }\n\n}\n\n.popupBreak{\n  margin-top: 20px;\n}\n\n.checkboxHeader{\n  margin-left: 34px;\n  font: 24px Omnes-ATT-W02-Medium;\n}\n  \n  .back-button-enrollDate {\n    padding-right: 40px;\n  }\n  .icon-alert {\n    color: #ffb81c !important;\n    margin: 0;\n  }\n\n  .enrollDateInfo {\n    padding: 30px 0 0;\n    margin: 0;\n\n    a {\n      padding: 0;\n    }\n\n    .alert-icon {\n      width: 20px;\n      float: left;\n      margin-right: 10px;\n    }\n\n    .extra-content {\n      float: left;\n      width: 88%;\n    }\n\n    .icon-alert {\n      width: 20px;\n      height: 20px;\n    }\n  }\n\n  .btn-link {\n    font: 1.8rem 'Omnes-ATT-W02';\n  }\n  tr {\n    th {\n      &:first-child {\n        width: 15%;\n      }\n    }\n  }\n  .list-container {\n    margin-top: 30px;\n  }\n\n  .padding{\n    padding-left:15px;\n  }\n\n  h2 {\n    margin-bottom: 30px;\n  }\n\n  ul {\n    li {\n      list-style-type: disc;\n      margin-left: 15px;\n    }\n}\n\n\n  .bullet{\n    list-style-type: none;\n  }\n\n\n  a {\n    cursor: pointer;\n    padding-right: 30px;\n  }\n\n  .model-box a {\n    padding-right: 19px;\n  }\n\n  .select-dates {\n    margin: 20px 0 0;\n\n    .device-header {\n      position: relative;\n\n      h3 {\n        display: inline-block;\n        font-size: 20px;\n        margin-bottom: 10px;\n      }\n\n      h4, .disable-label, .enable-label {\n        display: inline-block;\n        font-size: 14px;\n        margin-bottom: 10px;\n        &.disable-label {\n          color : #5a5a5a;\n        }\n      }\n\n      .tooltip-container {\n        border: none;\n        font-size: 17px;\n        position: relative;\n        top: -4px;\n      }\n    }\n\n    .enter-date {\n      width: 61%;\n    }\n\n    .error-msg {\n      color: color(danger, base);\n      font-family: 'Omnes-ATT-W02-Medium';\n      font-size: 14px;\n\n      i {\n        color: color(danger, base);\n        font-size: 15px;\n        margin-right: 4px;\n      }\n    }\n  }\n\n  .ios-message {\n    @include vendor-prefix('border-radius', 6px);\n    background-color: color(default, base);\n    border: 1px solid color(default, base);\n    margin: 20px 0 30px;\n    padding: 20px;\n  }\n  \n  .acc-content{\n    padding-bottom: 20px;\n  }\n  \n  .cta {\n    border-top:  1px solid color(default, dark);\n    margin-top: 30px;\n    margin-bottom: 30px;\n    padding: 30px 0 46px;\n\n    a,\n    button {\n      float: right;\n    }\n  }\n\n  .error-container {\n    .message {\n      font-family:'Omnes-ATT-W02';\n      font-size: 14px;\n      padding: 3px 0;\n    }\n  }\n\n  .accheader{\n    \n    font-family: 'Omnes-ATT-W02';\n  }\n\n  .accordion{\n    border-bottom: 1px solid  color(default, dark);\n  }\n\n  .supportArticles {\n    margin-bottom: 60px;\n  }\n  \n  @include respond-to (small) {\n    margin: 0px;\n    padding: 0 4%;\n    width: 100%;\n\n    .supportArticles {\n      margin-bottom: 30px;\n    }\n\n    h2 {\n      margin-bottom: 20px;\n    }\n\n    .select-dates {\n      width: 100%;\n\n      .device-header {\n\n        h3 {\n          font-size: 16px;\n        }\n        \n        h4 {\n          font-size: 12px;\n        }\n        \n        .tooltip-container {\n          position: static;\n        }\n\n        .helper-text {\n          border-radius: 0;\n          left: -4%;\n          width: 108%;\n          top: 31px;\n        }\n      }\n\n      .enter-date {\n        width: 100%;\n      }\n    }\n\n    .grid-table {\n      margin-left: -4%;\n      margin-right: -4%;\n    }\n\n    .ios-message {\n      margin: 20px 0;\n      padding: 20px 0;\n    }\n\n    .cta {\n      margin-top: 20px;\n      margin-bottom: 20px;\n      padding: 20px 0 70px;\n      text-align: center;\n\n      .btn {\n        margin-bottom: 5px;\n        width: 100%;\n      }\n\n      .a {\n        padding: 20px;\n      }\n    }\n\n    .error-container {\n      margin: 0 -4% 15px -4%;\n      border-radius: 0;\n\n      div {\n        border-radius: 0;\n      }\n\n      .message {\n        font-size: 12px;\n      }\n\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
